// migrationAmountDataSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { commonService } from "../../services/common.services";
import { apiConstants } from "../../constant/api.constant";

const initialState = {
    migrationData: [],
    loading: false,
    error: null,
};

// Async Thunk to fetch migration history
export const getMigrationAmountData = createAsyncThunk(
    "migrationHistory/getMigrationAmountData",
    async (data, { rejectWithValue }) => {
        try {
            const response = await commonService.getWithToken(apiConstants.GET_MIGRATION_DATA, data);
            if (response && response.success && response.data) {
                return response.data; // return whole array, not [0]
            } else {
                return rejectWithValue("Failed to fetch migration history.");
            }
        } catch (error) {
            return rejectWithValue(error.message || "An error occurred.");
        }
    }
);

const migrationAmountDataSlice = createSlice({
    name: "migrationAmountData",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getMigrationAmountData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getMigrationAmountData.fulfilled, (state, action) => {
                state.loading = false;
                state.migrationData = action.payload || [];
            })
            .addCase(getMigrationAmountData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to fetch data.";
            });
    },
});

export default migrationAmountDataSlice.reducer;
